import React, { useEffect, useState } from 'react';
import { TopXitemsList, DatatableDigitalAssets } from 'components';
import { getSource, list } from 'utils';
import { useTranslation } from 'react-i18next';

const DigitalAssets = ({ tenant, itemsPerPage = 5 }) => {
  const [items, setItems] = useState([]);
  const { t } = useTranslation();
  const isCancelled = React.useRef(false);

  // Get topX list.
  useEffect(() => {
    const source = getSource();

    list({
      resourceType: 'digitalAsset',
      params: [
        { label: 'page', value: 1 },
        { label: 'itemsPerPage', value: 3 },
        { label: 'order[stats.view]', value: 'desc' },
        { label: 'tenant[]', value: tenant['@uuid'] }
      ],
      success: {
        callback: (res) => {
          if (isCancelled.current) return;
          setItems(res.data);
        }
      },
      aOptions: { cancelToken: source.token }
    }).then();

    return () => {
      isCancelled.current = true;
      source.cancel();
      setItems([]);
    };

    // eslint-disable-next-line
  }, [tenant]);

  const topXsettings = {
    title: t('topModel'),
    desc: t('topModelDescView'),
    displayDivider: true,
    slider: false,
    type: 'digitalAsset',
    imgType: 'preview',
    imgAlt: 'logo-model',
    icon: ['fas', 'eye'],
    iconClass: 'text-success me-1'
  };

  return (
    <>
      <div className={'row'}>
        <div className={'col'}>
          <TopXitemsList
            items={items['hydra:member']}
            settings={topXsettings}
          />
        </div>
      </div>

      <div className={'row'}>
        <div className={'col'}>
          <DatatableDigitalAssets
            tenant={tenant}
            pagination={{ itemsPerPage: itemsPerPage }}
          />
        </div>
      </div>
    </>
  );
};

export default DigitalAssets;
